// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
    factory('gdsSettings', ['$http', 'obexConstant', 'authService',
      function ($http, obexConstant, authService) {
        return {
          getGdsSettingsByAgencyId(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlGdsSettingsV2}/organization/${id}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },
          getGdsSettingById(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlGdsSettings}/${id}`;
              return $http.get(url, {
                headers: authHeader,
              });
            });
          },
          addGdsSetting(gdsSetting, orgId) {
            return authService.getAuthorizationHeader().then(authHeader => {
              return $http.post(obexConstant.urlGdsSettings, gdsSetting, {
                headers: authHeader,
              });
            });
          },
          updateGdsSetting(id, gdsSetting) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlGdsSettings}/${id}`;
              return $http.put(url, gdsSetting, {
                headers: authHeader,
              });
            });
          },
          deleteGdsSetting(id) {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlGdsSettings}/${id}`;
              return $http.delete(url, {
                headers: authHeader,
              });
            });
          }
        };
      },
    ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/gdsSettings.service.js